import { CsvColumnValidation } from 'src/components/CsvUpload/types';

import { ValidateCsvArrayResult } from './types';

export const validateCsvArray = (
  data: string[],
  headers: CsvColumnValidation[]
): ValidateCsvArrayResult => {
  const errorMessageBuilder: string[] = [];

  const fileHeaders = data[0].split(',');

  const normalisedHeaders: Record<string, CsvColumnValidation> = {};
  headers.map((header) => {
    const headerKey = header.key;
    normalisedHeaders[headerKey] = header;

    // validate missing required header/empty recipient rows
    if (
      data.length == 1 ||
      !fileHeaders.some(
        (header) => header.replace(/[\n\r]+/g, '') === headerKey // remove clrf characters
      )
    ) {
      normalisedHeaders[headerKey].hasError = true;
      errorMessageBuilder.push(`${headerKey} is missing`);
    }
  });

  const errorRows: Record<string, number[]> = {};
  let validRowCount = 0;

  for (let i = 1; i < data.length; i += 1) {
    if (!data[i]) continue;

    validRowCount += 1;

    const rowData = data[i].split(',');

    for (let j = 0; j < fileHeaders.length; j += 1) {
      const headerKey = fileHeaders[j].replace(/[\n\r]+/g, '');

      // validate invalid/missing header
      if (!(headerKey in normalisedHeaders)) {
        continue;
      }

      if (normalisedHeaders[headerKey].required && !rowData[j]) {
        normalisedHeaders[headerKey].hasError = true;

        headerKey in errorRows
          ? errorRows[headerKey].push(i)
          : (errorRows[headerKey] = [i]);
      } else {
        normalisedHeaders[headerKey].isSuccess = true;
      }
    }
  }

  if (Object.keys(errorRows).length) {
    Object.keys(errorRows).map((headerKey) =>
      errorMessageBuilder.push(
        `${headerKey}: Rows ${errorRows[headerKey].join(',')}`
      )
    );
  }

  if (errorMessageBuilder.length) {
    return {
      headers, // no need to revert normalisedHeader since it is shallow copy
      isCsvValid: false,
      rows: 0
    };
  } else {
    return {
      headers,
      isCsvValid: true,
      rows: validRowCount
    };
  }
};
